import PropTypes from "prop-types";
import React from "react";
import Form from "react-bootstrap/Form";

function FormInputError(props) {
  const { name, formik, className } = props;
  return (
    <>
      {formik?.touched[name] && formik?.errors[name] ? (
        <Form.Text className={`form-error fs-12 lg-18 fw-500 text-danger ${className}`}>
          {formik?.errors[name]}
        </Form.Text>
      ) : null}
    </>
  );
}

export const defaultProps = {
  variant: "",
  type: "",
  className: "",
  placeholder: "",
  label: "",
  ariaLabel: "",
  ariaDescribedby: "",
  text: "",
};

export const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaDescribedby: PropTypes.string,
  disabled: PropTypes.bool,
  formik: PropTypes.object,
};

FormInputError.defaultProps = defaultProps;

FormInputError.propTypes = propTypes;
export default FormInputError;
